import styled from "styled-components";
import { FlexMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../styles/common/mixins/logical.styled.js";
import universalMusicThemes from "./themes/index.js";
export const Inputs = styled.div.withConfig({
    displayName: "styled__Inputs",
    componentId: "sc-9df12d5f-0"
})`
	width: 100%;
	${FlexMixin()}

	> * {
		border-right: 1px solid ${({ theme  })=>theme.colors.grays.light};
		width: 50%;
		&:first-child {
			input {
				${BorderRadius({
    topRight: '0',
    bottomRight: '0'
})}
			}
		}

		&:last-child {
			border-right: none;

			input {
				${BorderRadius({
    topLeft: '0',
    bottomLeft: '0'
})}
			}
		}

		&:not(:last-child):not(:first-child) {
			input {
				${BorderRadius({
    all: '0'
})}
			}
		}
	}

	${universalMusicThemes('Inputs')}
`;

//# sourceMappingURL=styled.js.map